import { Auth0Context } from '@auth0/auth0-react'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import React, { FC } from 'react'
import { Button, Heading } from 'react-bulma-components'

import { UiLoading } from '@/components/ui/loading'

import * as Presenter from './presenter'
import { Props } from './type'

export const ContainerSplash: FC<Props> = (props) => {
  const { loadedCurrent, connectedToAuth, connectedToBackend, authUser, current } = props
  if (!connectedToAuth) {
    return (
      <UiLoading>
        <Heading subtitle size={6}>
          認証サーバに接続中...
        </Heading>
      </UiLoading>
    )
  }

  if (!authUser) {
    return (
      <Presenter.Container>
        <Presenter.WarningIcon icon={faExclamationCircle} />
        <Heading subtitle size={6}>
          しばらくお待ちいただくか、後ほどログインを行ってください
        </Heading>
      </Presenter.Container>
    )
  }

  if (!connectedToBackend) {
    return (
      <UiLoading>
        <Heading subtitle size={6}>
          リソースサーバに接続中...
        </Heading>
      </UiLoading>
    )
  }

  if (!loadedCurrent) {
    return (
      <UiLoading>
        <Heading subtitle size={6}>
          {authUser.email} としてログイン中...
        </Heading>
      </UiLoading>
    )
  }

  if (!current) {
    return (
      <Auth0Context.Consumer>
        {({ logout }) => (
          <Presenter.Container>
            <Presenter.WarningIcon icon={faExclamationCircle} />
            <Heading subtitle size={6}>
              {authUser.email} としてログインできません
            </Heading>
            <Button onClick={() => logout()} text>
              別のアカウントでログインする
            </Button>
          </Presenter.Container>
        )}
      </Auth0Context.Consumer>
    )
  }
}
